import { NoRecordFound } from 'components/Common/Common';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import LoadingOverlay from 'components/shared/LoadingOverlay';
import TableLayout from 'components/TableLayout';
// import { START_SESSION } from 'config/paths';
import { convertToMomentDate, errorMessageToast, formatString, successMessageToast, userFullName } from 'helpers/common';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useNavigate, useParams, Link, generatePath } from 'react-router-dom';
import { useGetTaskDetailsQuery, useMarkTaskCompleteMutation } from 'store/services/staff';
import { CLIENT_TYPES } from 'config/constants';
import ConfirmationPop from 'components/Modals/ConfirmationPop';


const GroupStartSession = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [selectedOwnerId, setSelectedOwnerId] = useState('');
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [isTaskCompleted, setIsTaskCompleted] = useState('');

    const { taskId, clientId, staffId, taskType } = useParams();

    const { data, isLoading, isFetching, error } = useGetTaskDetailsQuery({ id: staffId, taskType: 'single', clientId, taskId }, { skip: !clientId });
    const [completeTask, { isLoading: completeTaskLoading }] = useMarkTaskCompleteMutation();

    const handleCompleteTask = async () => {
        try {
            setShowModal(false);
            let updateStatus = '';
            if (isTaskCompleted === 'completed') {
                updateStatus = 'pending';
            } else {
                updateStatus = 'completed';
            }
            const result = await completeTask({ task_id: selectedTaskId, owner: selectedOwnerId, updateStatus: updateStatus });
            setIsTaskCompleted('');
            setSelectedTaskId('');
            setSelectedOwnerId('');

            if (result?.error) return;

            successMessageToast(result?.data?.message);
            //   navigate(generatePath(CLIENTS, { activeTab: "Groups" }));

        } catch (err) {
            console.log("Error Completing Task", err);
        };
    };


    const column = [
        {
            head: "Schedule Date",
            accessor: "Session Date",
            isComponent: true,
            component: (item) => <>{convertToMomentDate(item?.schedule_date)}</>,
        },
        {
            head: "Attendance",
            accessor: "Tracker",
            component: (item) => <div className='text-capitalize'>{item?.attendance || "--"}</div>,
        },
        {
            head: "Status",
            accessor: "Confirmed",
            sorter: true,
            isComponent: true,
            component: (item) => (
                <p
                    style={{ width: 110 }}
                    className={`${item?.status === "pending" ? "redStatus" : "greenStatus"} status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {formatString(item?.status)}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "Action",
            isComponent: true,
            component: (item) => {
                const scheduleDate = new Date(item?.schedule_date);
                const currentDate = new Date();
                const isFutureDate = scheduleDate > currentDate;

                return (
                    <Button
                        className='commonBtn p-0'
                        style={{ height: "30px", minWidth: "100px", opacity: isFutureDate ? 0.5 : 1, }}
                        // disabled={isFutureDate}
                        onClick={() => {
                            if (isFutureDate) {
                                errorMessageToast("Cannot access future target plan.");
                                return;
                            }

                            const path = generatePath(
                                '/manage-parent/clients/sessionview/:taskType/:staffId/:clientId/:taskId',
                                {
                                    taskType: 'single',
                                    staffId: staffId,
                                    clientId: clientId,
                                    taskId: item?.assigned_task_id,
                                }
                            );

                            navigate(path, {
                                state: {
                                    task_datetime: moment
                                        .utc(item?.schedule_date)
                                        .format('YYYY-MM-DDTHH:mm:ssZ'),
                                },
                            });
                        }}
                    >
                        Target Plan
                    </Button>
                );
            },
        },
    ];

    if (isLoading) return <LoadingIndicator />;
    if (error) return <div>Error: {error.message}</div>;

    const getClientTypeLabel = (clientTypeValue) => {
        const clientType = CLIENT_TYPES.find(type => type.value === clientTypeValue);
        return clientType ? clientType.label : "--";
    };

    return (
        <>
            {isFetching && <LoadingOverlay />}
            {completeTaskLoading && <LoadingOverlay />}
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                type={isTaskCompleted === 'completed' ? "pending" : "complete"}
                confirmHandler={handleCompleteTask}
            />
            <section className='mt-3 border-bottom'>
                <Container fluid>
                    <Row className='justify-content-between align-items-center'>
                        <Col lg='6'>
                            <p className='mb-0'>Clients/ <span className='mb-0' style={{ fontWeight: "600" }}>Task Details</span></p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='mt-4'>
                <Container fluid>
                    <h4 className='m-0 fw-bold themeBlue text-capitalize'>{userFullName(data?.clientDetails?.associatedClient)}</h4>
                    <Row>
                        <Col lg='8'>
                            <Row>
                                {[
                                    { label: "Last Name", value: data?.clientDetails?.associatedGuardianClient?.lastname },
                                    { label: "First Name", value: data?.clientDetails?.associatedGuardianClient?.firstname },
                                    { label: "DOB", value: convertToMomentDate(data?.clientDetails?.associatedGuardianClient?.client_detail?.dob) },
                                    { label: "Name of Discipline", value: data?.tasks?.[0]?.associatedTasks?.owner?.therapist_detail?.therapist_discipline?.name },
                                    { label: "Supervisor", value: userFullName(data?.tasks?.[0]?.associatedTasks?.owner) },
                                    { label: "Categories Name", value: getClientTypeLabel(data?.clientDetails?.associatedGuardianClient?.client_detail?.client_type) },
                                    // { label: "Grade", value: data?.clientDetails?.associatedGuardianClient?.client_detail?.grade },
                                ].map((item, index) => (
                                    <Col md="4" sm="6" className='my-2' key={index}>
                                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                            <h6 className="m-0 themeBlue fw-bold">
                                                <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                                {item.label}
                                            </h6>
                                            <p className="m-0 themeBlue pt-2">{item.value || "--"}</p>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className='mt-4'>
                <Container fluid>
                    {
                        !data?.tasks?.length ? <NoRecordFound /> : data?.tasks?.map((item, index) => (
                            <div key={index} className='p-4 pb-0 rounded' style={{ backgroundColor: "#3DA0AA17" }}>
                                <div className="pb-4 h-100 rounded d-flex align-items-center">
                                    <h6 className="m-0 themeBlue fw-bold">
                                        <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                        Date
                                    </h6>
                                    <div className='d-flex ms-2 align-items-center'>
                                        {/* <img src={Images.calender_grey_img} alt="calender_grey_img" /> */}
                                        <p className="m-0 themeBlue ms-1">
                                            {convertToMomentDate(item?.associatedTasks?.createdAt)}
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <h5 className='m-0 fw-bold themeBlue text-capitalize'>{item?.associatedTasks?.task_title || "--"}</h5>
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsTaskCompleted(item?.associatedTasks?.status)
                                            setSelectedTaskId(item?.associatedTasks?.id);
                                            setSelectedOwnerId(item?.associatedTasks?.createdBy)
                                            setShowModal(true);
                                        }}
                                        className='commonBtn btn btn-primary p-0 mb-2'
                                        style={{
                                            height: "35px",
                                            backgroundColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : '',
                                            borderColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : ''
                                        }}
                                    >
                                        {/* Mark Complete */}
                                        {item?.associatedTasks?.status === "completed" ? "completed" : 'Mark Complete'}
                                    </Button>

                                </div>
                                <div className='group-details-table'>
                                    <TableLayout column={column} data={item?.occurrences || []} />
                                </div>
                            </div>
                        ))
                    }
                </Container>
            </section>
        </>
    );
}

export default GroupStartSession;